import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { StoreModule } from '@ngrx/store';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { NgxMaskModule } from 'ngx-mask';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AUTH_PROVIDER } from './shared/constants/auth-config.constant';
import { RecaptchaV3Module } from 'ng-recaptcha';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { WINDOW_PROVIDERS } from './shared/services/window.service';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { AccessTokenInterceptor } from './shared/interceptors/access-token.interceptor';
//import { CacheInterceptor } from './shared/interceptors/cache.interceptor';
import { LoginInterceptor } from './shared/interceptors/login.interceptor';
import { NGX_MASK_CONFIGURATION } from './shared/constants/ngx-mask-configuration.constant';
import { RECAPTCHA_V3_CONFIGURATION } from './shared/constants/recaptcha-v3-configuration.constant';
import { REDUCERS } from './shared/constants/reducers.constant';
import { STORE_CONFIGURATION } from './shared/constants/store-configuration.constant';
import { TOASTR_CONFIGURATION } from './shared/constants/toastr-configuration.constant';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { stringToBoolean } from 'src/app/shared/utils/string-to-boolean.util';
import { NgxPrintModule } from 'ngx-print';

const MODULES = [
  AppRoutingModule,
  BrowserAnimationsModule,
  BrowserModule,
  HttpClientModule,
  NgProgressModule,
  NgProgressRouterModule,
  NgxMaskModule.forRoot(NGX_MASK_CONFIGURATION),
  OAuthModule.forRoot(),
  IonicModule.forRoot(),
  RecaptchaV3Module,
  ServiceWorkerModule.register('ngsw-worker.js', {
    enabled: stringToBoolean(environment.production) || stringToBoolean(environment.homologation),
    registrationStrategy: 'registerWhenStable:30000'
  }),
  SharedModule,
  StoreModule.forRoot(REDUCERS, STORE_CONFIGURATION),
  ToastrModule.forRoot(TOASTR_CONFIGURATION),
  NgxPrintModule
];

const SERVICES = [RECAPTCHA_V3_CONFIGURATION, WINDOW_PROVIDERS, AUTH_PROVIDER];

const INTERCEPTORS = [
  //{ provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AccessTokenInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoginInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];

@NgModule({
  declarations: [AppComponent],
  imports: [...MODULES],
  providers: [...SERVICES, ...INTERCEPTORS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}
